import * as React from 'react'
import { Table } from 'react-bootstrap';
import { Container, IAppState } from '../Container';
import { ContactUs } from '../../components/section/ContactUs';
import { CopyrightFooter } from '../../components/section/CopyrightFooter';
import { DataAsOf } from 'app/components/visualizations/DataAsOf';
import { AssetClassReturns } from 'app/components/visualizations/AssetClassReturns';

interface ITableData {
  years: any[]
  rows: any[]
}

interface IndexValue {
  name: string
  className: string
  index: string
  year: number
  threeYear: number
  fiveYear: number
  tenYear: number
  yearToDate: number
  threeMonth: number
  oneMonth: number
}

interface IAnnualInvestmentState {
  isReportsTableShown: boolean
  isLoggedIn: boolean
  username: string
  key: string
  tableData: ITableData
  summaryData: IndexValue[]
  hoverClass: string
  isHovered: boolean
}

class AnnualInvestment extends Container<{}, IAnnualInvestmentState> {
  state: IAnnualInvestmentState = {
    isLoggedIn: false,
    username: '',
    key: '',
    isReportsTableShown: false,
    hoverClass: '',
    isHovered: false,
    summaryData: [],
    tableData: {
      years: [],
      rows: []
    }
  }

  mapAppStateToContainerState(appState: IAppState): IAnnualInvestmentState {
    const isLoggedIn = !!appState.User.username
    const username = appState.User.username
    const key = appState.User.token
    const tableData = { years: [], rows: [] }
    const summaryData = []
    return { isLoggedIn, username, key, isReportsTableShown: false, tableData, hoverClass: '', isHovered: false, summaryData }
  }

  componentWillMount() {
    super.componentWillMount()
  }

  componentDidMount() {
    this.loadPerformanceSummary()
    this.loadPerformanceTable()
  }

  loadPerformanceTable() {
    const assetLevelRequest = { method: 'POST', body: JSON.stringify({ action: 'index', state: '', assetLevel: 0, monthNumber: 12 }) }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark', assetLevelRequest)
      .then((resp) => resp.json())
      .then((json) => {
        const years = json.indexValues.years
        const rows = []
        rows.push(json.indexValues.rowOne)
        rows.push(json.indexValues.rowTwo)
        rows.push(json.indexValues.rowThree)
        rows.push(json.indexValues.rowFour)
        rows.push(json.indexValues.rowFive)
        rows.push(json.indexValues.rowSix)
        rows.push(json.indexValues.rowSeven)

        const tableData = { years, rows }
        this.setState({ tableData })
      })
  }

  loadPerformanceSummary() {
    const assetLevelRequest = {
      method: 'POST', body: JSON.stringify({ action: 'getAnnualizedDataTable', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } })
    }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', assetLevelRequest)
      .then((response) => {
        return response.text()
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&')
        text = text.replace(/\\/g, "")
        return JSON.parse(text)
      })
      .then((json) => {
        const summaryData = json

        this.setState({ summaryData })
      })
  }

  updateHoverClass(event) {
    const hoverClass = (event.type === 'mouseleave') ? '' : event.target.className.split(' ')[0]
    this.setState({ hoverClass })
  }

  render() {
    const { years, rows } = this.state.tableData
    const { hoverClass } = this.state
    return (
      <section>
        <div className="container" id="assetClassReturns">
          <h3>Annual Investment Performance by Asset Class</h3>
          <p>FoundationMark shows investment returns by asset class sorted best to worst. </p>
          <DataAsOf />
          <AssetClassReturns />
          <section>
            <Table bordered style={{ textAlign: 'center', fontSize: '.9em' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Name</th>
                  <th style={{ textAlign: 'center' }}>Description</th>
                  <th style={{ textAlign: 'center' }}>YTD</th>
                  <th style={{ textAlign: 'center' }}>1 Year</th>
                  <th style={{ textAlign: 'center' }}>3 Yr</th>
                  <th style={{ textAlign: 'center' }}>5 Yr</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.summaryData.map((summary) => {
                    return (
                      <tr>
                        <td className={summary.className + ((hoverClass !== '' && summary.className !== hoverClass) ? ' fade-class ' : '')}>{summary.index}</td>
                        <td>{summary.name}</td>
                        <td>{summary.yearToDate.toFixed(1)}%</td>
                        <td>{summary.year.toFixed(1)}%</td>
                        <td>{summary.threeYear.toFixed(1)}%</td>
                        <td>{summary.fiveYear.toFixed(1)}%</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </section>
        </div>
        <footer className="margin-y-xl">
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    )
  }
}

export {
  AnnualInvestment
}



// WEBPACK FOOTER //
// ./src/app/containers/AnnualInvestment/index.tsx